var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.12 62.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #231916;\n        stroke-miterlimit: 10;\n        stroke-width: 3.59px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #231916;\n      }\n\n      .cls-3, .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 60.88,
    x2: 82.12,
    y2: 60.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.62,
    y: 29.02,
    width: 11.7,
    height: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17,30.33v28.88H7.92v-28.88h9.08m2.62-2.62H5.31v34.11h14.32V27.71h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.17,
    y: 12.63,
    width: 11.7,
    height: 47.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m34.56,13.94v45.27h-9.08V13.94h9.08m2.62-2.62h-14.32v50.5h14.32V11.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.72,
    y: 16.64,
    width: 11.7,
    height: 43.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.11,17.95v41.26h-9.08V17.95h9.08m2.62-2.62h-14.32v46.49h14.32V15.33h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.28,
    y: 1.31,
    width: 11.7,
    height: 59.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m69.67,2.62v56.59h-9.08V2.62h9.08m2.62-2.62h-14.32v61.82h14.32V0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/bar_chart_icon.0fc914b976bed3b5a4271228d5bd0478.svg";
export { ForwardRef as ReactComponent };